import { twMerge } from "tailwind-merge";

interface LoadingProps {
  message?: string;
  borderColor?: string;
  messageColor?: string;
  className?: string;
}

const Loading = ({ message = "Loading...", borderColor = 'border-brand-600', messageColor = 'text-gray-600', className = '' }: LoadingProps) => {
  return (
    <div className={twMerge("flex justify-center space-x-2", className)}>
      <div className={twMerge("animate-spin rounded-full h-4 w-4 border-b-2", borderColor)}></div>
      <span className={messageColor}>{`${message}`}</span>
    </div>
  );
};

export default Loading;
